import { FC, useState } from "react";
import { TooltipProps } from "./ToolTip.props";
import cn from "classnames";
import styles from "./ToolTip.module.scss";

/**
 * @deprecated Use `import { Tooltip } from capitalrx-components-2.0/lib/general` instead.
 */
export const Tooltip: FC<TooltipProps> = ({ children, className, id, container }) => {
  const tooltipClassnames = cn(styles.tooltip, className);
  const [hovered, setHovered] = useState(false);

  return (
    <span
      id={id}
      data-testid={`test__${id}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={styles.container}
    >
      {container}
      <div className={hovered ? tooltipClassnames : styles.none}>{children}</div>
    </span>
  );
};
